import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Std$Bolt0 from "bolt0/./std.bs.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Caml_js_exceptions from "bs-platform/lib/es6/caml_js_exceptions.js";
import * as Api_version$SolvuuApi0 from "./api_version.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";
import * as Service_get_by_id_request_atd$SolvuuApi0 from "./service_get_by_id_request_atd.bs.js";

function failwith_unexpected_entity_in_path(service, entity, path) {
  return Pervasives.failwith(Curry._3(Printf.sprintf(
  /* Format */
  [
  /* String */
  Block.__(2, [
  /* No_padding */
  0,
  /* String_literal */
  Block.__(11, [" path expected to begin with ",
  /* String */
  Block.__(2, [
  /* No_padding */
  0,
  /* String_literal */
  Block.__(11, [" but got ",
  /* String */
  Block.__(2, [
  /* No_padding */
  0,
  /* End_of_format */
  0])])])])]), "%s path expected to begin with %s but got %s"]), service, entity, $$String.concat("/", path)));
}

function failwith_unexpected_path(service, path) {
  return Pervasives.failwith(Curry._2(Printf.sprintf(
  /* Format */
  [
  /* String */
  Block.__(2, [
  /* No_padding */
  0,
  /* String_literal */
  Block.__(11, [" path ",
  /* String */
  Block.__(2, [
  /* No_padding */
  0,
  /* String_literal */
  Block.__(11, [" not of expected form",
  /* End_of_format */
  0])])])]), "%s path %s not of expected form"]), service, $$String.concat("/", path)));
}

function path(p, version) {
  var _path = $$String.split_on_char(
  /* "/" */
  47, p);

  if (_path && _path[0] === "") {
    var match = _path[1];

    if (match && $$String.equal(match[0], Api_version$SolvuuApi0.to_string(version))) {
      return match[1];
    }
  }

  return Curry._2(Std$Bolt0.failwithf(
  /* Format */
  [
  /* String_literal */
  Block.__(11, ["invalid path ",
  /* String */
  Block.__(2, [
  /* No_padding */
  0,
  /* End_of_format */
  0])]), "invalid path %s"]), p,
  /* () */
  0);
}

var Exn = {
  path: path
};

function path$1(p, version) {
  try {
    return (
      /* `Ok */
      [17724, path(p, version)]
    );
  } catch (raw_exn) {
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);

    if (exn[0] === Caml_builtin_exceptions.failure) {
      return (
        /* `Invalid_path */
        [-677555379, exn[1]]
      );
    } else {
      throw exn;
    }
  }
}

function service(entity) {
  return entity + ".Get_all";
}

function path$2(entity) {
  return (
    /* :: */
    [entity,
    /* [] */
    0]
  );
}

var $$Request = {
  path: path$2,
  body:
  /* None */
  870530776,
  info:
  /* () */
  0
};
var Get_all = {
  service: service,
  $$Request: $$Request
};

function service$1(entity) {
  return entity + ".Get_by_id";
}

function path$3(entity, param) {
  return (
    /* :: */
    [entity,
    /* :: */
    [param.id,
    /* [] */
    0]]
  );
}

function body(x) {
  return (
    /* `Json */
    [826371656, Curry._1(Service_get_by_id_request_atd$SolvuuApi0.json_of_info, x)]
  );
}

function info(entity, path, param) {
  var service = entity + ".Get_by_id";

  if (path) {
    var match = path[1];

    if (match && !match[1]) {
      var match$1 = $$String.equal(entity, path[0]);

      if (match$1) {
        return {
          id: match[0]
        };
      } else {
        return failwith_unexpected_entity_in_path(service, entity, path);
      }
    } else {
      return failwith_unexpected_path(service, path);
    }
  } else {
    return failwith_unexpected_path(service, path);
  }
}

var $$Request$1 = {
  path: path$3,
  body: body,
  info: info
};
var Get_by_id = {
  service: service$1,
  $$Request: $$Request$1
};

function service$2(entity) {
  return entity + ".Get_events";
}

function path$4(entity, param) {
  return (
    /* :: */
    [entity,
    /* :: */
    [param.id,
    /* :: */
    ["events",
    /* [] */
    0]]]
  );
}

function info$1(entity, path, param) {
  var service = entity + ".Get_events";

  if (path) {
    var match = path[1];

    if (match) {
      var match$1 = match[1];

      if (match$1 && match$1[0] === "events" && !match$1[1]) {
        var match$2 = $$String.equal(entity, path[0]);

        if (match$2) {
          return {
            id: match[0]
          };
        } else {
          return failwith_unexpected_entity_in_path(service, entity, path);
        }
      } else {
        return failwith_unexpected_path(service, path);
      }
    } else {
      return failwith_unexpected_path(service, path);
    }
  } else {
    return failwith_unexpected_path(service, path);
  }
}

var $$Request$2 = {
  path: path$4,
  body:
  /* None */
  870530776,
  info: info$1
};
var Get_events = {
  service: service$2,
  $$Request: $$Request$2
};

function service$3(entity) {
  return entity + ".Create";
}

function path$5(entity) {
  return (
    /* :: */
    [entity,
    /* [] */
    0]
  );
}

function body$1(json_of_info, x) {
  return (
    /* `Json */
    [826371656, Curry._1(json_of_info, x)]
  );
}

function info$2(info_of_json, param, body) {
  if (typeof body === "number") {
    return Pervasives.failwith("invalid empty body");
  } else {
    return Curry._1(info_of_json, body[1]);
  }
}

var $$Request$3 = {
  path: path$5,
  body: body$1,
  info: info$2
};
var Create = {
  service: service$3,
  $$Request: $$Request$3
};
var $$Request$4 =
/* alias */
0;
var $$Response =
/* alias */
0;
export { $$Request$4 as $$Request, $$Response, path$1 as path, Get_all, Get_by_id, Get_events, Create, failwith_unexpected_entity_in_path, failwith_unexpected_path, Exn };
/* Api_version-SolvuuApi0 Not a pure module */